export const optionsBankAccNewStatus = [
	{
		name: 'Rascunho',
		value: 'Draft'
	},
	{
		name: 'Aprovação',
		value: 'Approval'
	},
	{
		name: 'Abertura',
		value: 'Processing'
	},
	{
		name: 'Ativa',
		value: 'Active'
	},
	{
		name: 'Encerrado',
		value: 'Closed'
	},
	{
		name: 'Expirado',
		value: 'Timeout'
	},
	{
		name: 'Cancelado',
		value: 'Cancel'
	},
	{
		name: 'Revisão',
		value: 'Revision'
	},
	{
		name: 'Assinaturas',
		value: 'Signatures'
	},
	{
		name: 'Pré-Análise Corban',
		value: 'CorbanPreAnalysis'
	}
];